import kitsStore from "./kits.store";

export default {kitsStore};
